import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { toVimeoPictures, VimeoOEmbed, VimeoPicture, VimeoPicturesResponse } from '../helpers/vimeo'
import { internalApiserverApi } from './internal-apiserver'

export const vimeoOEmbedUrl = (vimeoId: string) => `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${vimeoId}`)}`

const vimeoApi = internalApiserverApi.injectEndpoints({
  endpoints: (builder) => ({
    getVimeoOEmbed: builder.query<VimeoOEmbed, string>({
      // Vimeo's public oEmbed needs no token. GameRefinery's videos are domain-restricted, so it only
      // answers their title and thumbnail when the browser's Referer is a GameRefinery page.
      queryFn: async (vimeoId) => {
        try {
          const response = await fetch(vimeoOEmbedUrl(vimeoId), { credentials: 'omit' })
          if (!response.ok) return { error: { status: response.status, data: undefined } as FetchBaseQueryError }
          const data = await response.json()
          if (!data.thumbnail_url) return { error: { status: 403, data } as FetchBaseQueryError }
          return {
            data: { vimeoId: String(data.video_id ?? vimeoId), title: data.title ?? '', durationSeconds: data.duration ?? 0, thumbnailUrl: data.thumbnail_url },
          }
        } catch (error) {
          return { error: { status: 'FETCH_ERROR', error: String(error) } as FetchBaseQueryError }
        }
      },
    }),
    // Every picture of the video, through apiserver: Vimeo's API needs a token, which stays on the backend.
    getVimeoPictures: builder.query<VimeoPicture[], string>({
      // A stored id can carry extra characters (one is "/907865396"); the proxy takes only the number.
      query: (vimeoId) => `i/vimeo/videos/${encodeURIComponent(vimeoId.match(/\d+/)?.[0] ?? vimeoId)}/pictures`,
      transformResponse: (response: VimeoPicturesResponse) => toVimeoPictures(response),
    }),
  }),
})

export const { useLazyGetVimeoOEmbedQuery, useGetVimeoOEmbedQuery, useGetVimeoPicturesQuery } = vimeoApi
